export default "__VITE_ASSET__bheEb$k0__"